/**
 * Messages Component
 *
 * @description
 * This component is designed to handle multiple chat conversations.
 * It manages group selection, message display, and provides both desktop and mobile views.
 *
 * @remarks
 * Some features are currently commented out to simplify the implementation:
 * - GroupList component (both desktop sidebar and mobile drawer versions)
 * - handleSelectGroup function for manual group selection
 *
 * These commented sections can be uncommented when multiple chat group functionality is needed.
 *
 * @features
 * - Fetches available groups from API
 * - Auto-selects first group on load
 * - Persists selected group to localStorage
 * - Syncs groups from localStorage periodically
 * - Displays MessageBox for the selected group
 * - Mobile-responsive with drawer toggle (commented out)
 *
 * @returns JSX.Element - The messages page component
 */

import { useEffect, useState } from "react";
import { GROUPS } from "../../api/endPoint";
import MessageBox from "../../component/message-box/MessageBox";
// import GroupList from "../../component/message-box/GroupList";
import useFetch from "../../hooks/useFetch";
// import { List } from "lucide-react";
import { IGroup } from "../../types/group";

const Messages = () => {
  const { data: groupRes } = useFetch<any>(GROUPS, "GET");

  const [selectedGroup, setSelectedGroup] = useState<IGroup>();
  const [showSelector, setShowSelector] = useState(true);
  // const [showMobileDrawer, setShowMobileDrawer] = useState(false);
  const [, setGroups] = useState<IGroup[]>([]);

  useEffect(() => {
    // Check if a group is already selected in localStorage
    const savedGroup = localStorage.getItem("directMessage");
    if (savedGroup) {
      try {
        const parsedGroup = JSON.parse(savedGroup);
        setSelectedGroup(parsedGroup);
        setShowSelector(false);
      } catch (error) {
        console.error("Error parsing saved group:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (groupRes && groupRes.length > 0) {
      const nonDirectGroup = groupRes.find(
        (group: IGroup) => group.isDirectMsg === false
      );
      if (nonDirectGroup) {
        setSelectedGroup(nonDirectGroup);
        setShowSelector(false);
        localStorage.setItem("directMessage", JSON.stringify(nonDirectGroup));
        localStorage.setItem("groups", JSON.stringify(groupRes || []));
      } else {
        setShowSelector(false);
      }
    }
  }, [groupRes]);

  // Sync groups from localStorage periodically to catch updates from MessageBox
  useEffect(() => {
    const syncGroups = () => {
      const storedGroups = JSON.parse(localStorage.getItem("groups") || "[]");
      if (storedGroups.length > 0) {
        setGroups(storedGroups);
      }
    };

    // Sync immediately
    syncGroups();

    // Set up interval to sync every second
    const interval = setInterval(syncGroups, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Auto-select first group if none selected and groups are available
    if (
      !selectedGroup &&
      Array.isArray(groupRes) &&
      groupRes.length > 0 &&
      showSelector
    ) {
      setSelectedGroup(groupRes[0]);
    }
  }, [groupRes, selectedGroup, showSelector]);

  // const handleSelectGroup = (group: any) => {
  //   setSelectedGroup(group);
  //   localStorage.setItem("directMessage", JSON.stringify(group));
  // };

  // Show loading or empty state
  if (
    !groupRes ||
    groupRes.length === 0 ||
    groupRes.find((group: IGroup) => group.isDirectMsg === false) === undefined
  ) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-gray-500">No groups available</p>
      </div>
    );
  }

  return (
    <>
      {!showSelector && (
        <div className="flex overflow-hidden">
          {/* Desktop Sidebar */}
          {/* <GroupList
            groups={groups}
            selectedGroup={selectedGroup || null}
            onSelectGroup={handleSelectGroup}
            isMobile={false}
          /> */}

          {/* Mobile Drawer */}
          {/* {showMobileDrawer && (
            <GroupList
              groups={groups}
              selectedGroup={selectedGroup || null}
              onSelectGroup={handleSelectGroup}
              isMobile={true}
              onClose={() => setShowMobileDrawer(false)}
            />
          )} */}

          {/* Main Chat Area */}
          {/* {!showMobileDrawer && ( */}
          <div className="flex-1 flex flex-col relative">
            {/* Floating Menu Button for Mobile */}
            {/* <button
                onClick={() => setShowMobileDrawer(true)}
                className="lg:hidden fixed top-100 left-4 z-5 p-2 bg-primary-50 backdrop-blur-md hover:bg-primary-50 rounded-full shadow-lg transition-colors border border-primary-50"
              >
                <List className="w-6 h-6 text-primary-700" />
              </button> */}

            {/* MessageBox */}
            <div className="flex-1 overflow-hidden">
              {selectedGroup && <MessageBox selectedGroup={selectedGroup} />}
            </div>
          </div>
          {/* )} */}
        </div>
      )}
    </>
  );
};
export default Messages;
